import { render } from "./CargoHold.vue?vue&type=template&id=12c96511"
import script from "./CargoHold.vue?vue&type=script&lang=js"
export * from "./CargoHold.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__